import {Routes, Route} from 'react-router-dom';
import Main from "./Main";
import Unsubscribe from './Unsubscribe';

function App() {
  return (
     <div className="App">
     <Routes>
          <Route  path="/" element={<Main/>}></Route>
          <Route path="/:awb" element={<Main/>}></Route>
          <Route  path="/Unsubscribe" element={<Unsubscribe/>}></Route>
          <Route  path="/UnsubscribeAll" element={<Unsubscribe/>}></Route>
      </Routes>
    </div>
  );
}

export default App;
